import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/include/BtnFloatContact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/include/BtnScrollTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/nextjs-toploader/dist/index.js");
